import React, { useState, useEffect } from 'react'
import style from './style.module.less'
import { Modal, Form, Alert } from 'hljd'
import CheckboxTag from '@common/CheckboxTag'
import Api from '@api/contentCenter'
import { getMerchantInfo } from '@util'

const AddTags = props => {
  const [form] = Form.useForm()
  const [visible, setVisible] = useState(false)
  const [tagList, setTagList] = useState([])

  useEffect(() => {
    getTags()
  }, [])

  const getTags = async () => {
    const { data, success } = await Api.getTags({
      property_id: getMerchantInfo().property_id,
      commodity_type: 1
    })
    if (success) {
      setTagList(data)
    }
  }

  const handleSubmit = () => {
    form.validateFields().then(res => {
      props.onChange && props.onChange(res)
      setVisible(false)
    })
  }

  const handleCancel = () => {
    if (props.value) {
      form.setFields(
        Object.keys(props.value).map(k => ({
          name: k,
          value: props.value[k]
        }))
      )
    } else {
      form.resetFields()
    }
    setVisible(false)
  }

  const getSelectCount = values => {
    if (!values) {
      return
    }
    let count = 0
    Object.keys(values)
      .filter(k => values[k])
      .forEach(e => {
        count += values[e].length
      })
    return count
  }

  return (
    <div className={style.addTags}>
      <button
        type="button"
        onClick={() => setVisible(true)}
        className={style.button}
      >
        <span>
          {getSelectCount(props.value)
            ? `已添加(${getSelectCount(props.value)})`
            : '添加标签'}
        </span>
      </button>
      <Modal
        onOk={handleSubmit}
        width={800}
        title={'选择标签'}
        onCancel={handleCancel}
        visible={visible}
        destroyOnClose
      >
        <div className={style.alert}>
          <Alert
            message="标签会影响在首页、频道、搜索等页面的推荐，更精准的设置标签，快速获得更高的曝光和转化。"
            type="info"
            showIcon
          />
        </div>
        <Form form={form}>
          {tagList.map(tags => (
            <Form.Item
              key={tags.id}
              label={tags.name}
              name={tags.id}
              rules={[
                {
                  type: 'array',
                  max: tags?.quantity_range[1] ?? 1,
                  message: `该标签最多可选择${tags?.quantity_range[1] ?? 1}个`
                }
              ]}
            >
              <CheckboxTag
                style={{
                  height: 32,
                  lineHeight: '32px',
                  padding: '0 12px',
                  fontSize: 13
                }}
                max={tags?.quantity_range[1]}
                options={tags.children
                  .filter(f => f.deleted != 1)
                  .map(item => ({
                    name: item.name,
                    value: item.mark_id
                  }))}
              />
            </Form.Item>
          ))}
        </Form>
      </Modal>
    </div>
  )
}

export default AddTags
